import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  title: 'Pika-aloitus',
  description: 'Käy tämä opas läpi päästäksesi julkaisuun mahdollisimman nopeasti',
  steps: {
    [ONBOARDING_GUIDE_STEPS.Notifications]: 'Ilmoitusasetukset',
    [ONBOARDING_GUIDE_STEPS.OpenTimesAndLocation]: 'Aukioloajat ja sijainti',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Ravintolan identiteetti',
    [ONBOARDING_GUIDE_STEPS.OrderSettings]: 'Tilausasetukset',
    [ONBOARDING_GUIDE_STEPS.Menu]: 'Valikon asetukset',
    [ONBOARDING_GUIDE_STEPS.Marketing]: 'Markkinointi ja kanta-asiakasohjelma',
    [ONBOARDING_GUIDE_STEPS.MyStore]: 'Oma kauppa',
    [ONBOARDING_GUIDE_STEPS.GoLive]: 'Julkaise',
    [ONBOARDING_GUIDE_STEPS.Complete]: 'Valmis',
  },
  toasts: {
    failed_to_load_onboarding: 'Käyttöönottovaiheiden lataaminen epäonnistui',
  },
};
